import * as React from 'react';

import { observer } from 'mobx-react';

import { Body2 } from '@estee/elc-typography';
import { useTranslation } from '~utils/hooks/translations';

import { classes } from '~utils/Classes';

export interface IAdditionalTerms {
    additionalTermsLabelKey?: string;
}

const additionalTermsClassName = classes('iam-additional-terms');

export const AdditionalTerms = observer((props: IAdditionalTerms) => {
    const { additionalTermsLabelKey } = props;
    const translations = useTranslation();

    if (!additionalTermsLabelKey) {
        return null;
    }

    return (
        <Body2
            className={additionalTermsClassName}
            dangerouslySetInnerHTML={{
                __html: translations[additionalTermsLabelKey] || ''
            }}
        />
    );
});
